import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { Visit } from 'src/app/admin/models/visit.model';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { UserService } from 'src/app/admin/services/user.service';
import { VisitService } from 'src/app/admin/services/visit.service';
import { VisitorService } from 'src/app/admin/services/visitor.service';

@Component({
  selector: 'app-manage-visits',
  templateUrl: './manage-visits.component.html',
  styleUrls: ['./manage-visits.component.scss'],
})
export class ManageVisitsComponent implements OnInit {
  paginationSettings = { totalItems: 0 };
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  currentPage: number = 1;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  itemsPerPage: number = 10;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  fullNameQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  birthDateQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  roomQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  statusQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  dateQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  dateQueryEnd: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  roomName: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  enterTimeQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  enterTimeQueryEnd: string = '';
  packageTicketType: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  timeZoneQuery: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
  gratis: boolean
  gratisQuery: string = ""
  visits$ = this.visitService.visit$;
  visitors$ = this.visitorService.visitors$;
  playrooms$ = this.roomService.playrooms$;
  visit: Visit = new Visit();
  private currentUserSource = new ReplaySubject<User>(1);
  currentUser$ = this.currentUserSource.asObservable();
  pageSize: number = 2147483647;
  //datee=dateTame;
  dateTime: Date;

  constructor(private visitService: VisitService,
    private visitorService: VisitorService, private roomService: PlayroomService) { }

  ngOnInit(): void {
    this.loadVisit();
    if (this.isAdminRole()) {
      this.roomService.getAllPlayrooms();
    }
  }

  getStatus(value: number) {
    if (value === 0) {
      return 'U toku';
      // eslint-disable-next-line no-trailing-spaces
    }
    else if (value === 1) {
      return 'Završeno';
      // eslint-disable-next-line no-trailing-spaces
    }
    else if (value === 2) {
      return 'Kartica nije vraćena';
      // eslint-disable-next-line no-trailing-spaces
    }
    else if (value === 3) {
      return 'Automatski zatvoreno';
    }
  }

  getSurcharge(value: boolean) {
    if (value) {
      return "DA";
    }
    else {
      return "NE";
    }
  }

  getGratis(value: boolean) {
    if (value == true) {

      return "DA"
    }
    else {
      return "";
    }
  }

  onGratisChange(value: string) {
    if (value === '1') {
      this.gratisQuery = "true";
    } else if (value === '2') {
      this.gratisQuery = "false";
    } else {
      this.gratisQuery = null;
    }
  }

  loadVisit() {
    this.currentPage = 1
    this.visitService.getAllVisitsAdminManagerRole({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery, birthDateQuery: this.birthDateQuery, roomQuery: this.roomQuery, statusQuery: this.statusQuery,
      dateQuery: this.dateQuery, dateQueryEnd: this.dateQueryEnd, enterTimeQuery: this.enterTimeQuery, enterTimeQueryEnd: this.enterTimeQueryEnd,
      timeZoneQuery: this.timeZoneQuery, gratisQuery: this.gratisQuery, packageTicketType: this.packageTicketType
    });
    this.visitService.paginationSettings$.subscribe(pagSettings => {
      this.paginationSettings = pagSettings;
    });
  }

  resetFilters() {
    if (this.isAdminRole()) {
      this.roomService.getAllPlayrooms();
      this.roomName = '';
    }
    this.visitService.getAllVisitsAdminManagerRole();
    this.fullNameQuery = '';
    this.birthDateQuery = '';
    this.roomQuery = '';
    this.statusQuery = '';
    this.dateQuery = '';
    this.dateQueryEnd = '';
    this.enterTimeQuery = '';
    this.enterTimeQueryEnd = '';
    this.timeZoneQuery = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.gratisQuery = '';
    this.packageTicketType = '';
    this.gratis = null;
  }

  changePage(pageNumber) {
    this.currentPage = pageNumber;
    this.visitService.getAllVisitsAdminManagerRole({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery, birthDateQuery: this.birthDateQuery, roomQuery: this.roomQuery, statusQuery: this.statusQuery,
      dateQuery: this.dateQuery, dateQueryEnd: this.dateQueryEnd, enterTimeQuery: this.enterTimeQuery, enterTimeQueryEnd: this.enterTimeQueryEnd,
      timeZoneQuery: this.timeZoneQuery, gratisQuery: this.gratisQuery, packageTicketType: this.packageTicketType
    });
  }

  getTimeInside(visit: any) {
    const enter: any = new Date(visit.enter);
    const now: any = new Date(new Date().toISOString().slice(0, -1));

    if (visit.status === 0) {
      const diffMs = (now - enter);
      const diffDays = Math.floor(diffMs / 86400000);
      const diffHrs = Math.floor((diffMs % 86400000) / 3600000);
      const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
      const hrs = diffDays >= 1 ? (diffDays * 24) + diffHrs : diffHrs;

      return `${hrs.toString().length === 1 ? '0' : ''}${hrs}:${diffMins.toString().length === 1 ? '0' : ''}${diffMins}`;

    } else if (visit.status === 1 || visit.status === 2 || visit.status === 3) {
      const leave: any = new Date(visit.leave);
      const diffMs = leave - enter;
      const diffDays = Math.floor(diffMs / 86400000);
      const diffHrs = Math.floor((diffMs % 86400000) / 3600000);
      const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
      const hrs = diffDays >= 1 ? (diffDays * 24) + diffHrs : diffHrs;

      return `${hrs.toString().length === 1 ? '0' : ''}${hrs}:${diffMins.toString().length === 1 ? '0' : ''}${diffMins}`;
    }
  }

  blobToFile(data: any, type: string, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);
    a.href = url; a.download = fileName; a.click();
    window.URL.revokeObjectURL(url);
  }

  CSV() {
    this.visitService.exportCSV({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage, pageSize: this.pageSize,
      fullNameQuery: this.fullNameQuery, birthDateQuery: this.birthDateQuery, roomQuery: this.roomQuery, statusQuery:
        this.statusQuery, dateQuery: this.dateQuery, dateQueryEnd: this.dateQueryEnd, enterTimeQuery: this.enterTimeQuery,
      enterTimeQueryEnd: this.enterTimeQueryEnd, gratisQuery: this.gratisQuery, packageTicketType: this.packageTicketType
    }).subscribe
      (
        response => {
          this.blobToFile(response, "text/csv", "Export.csv");
        }
      )

  }

  isAdminRole() {
    let isAdminWithoutRoom = false;
    this.currentUser$.subscribe(jwt => {
      // eslint-disable-next-line @typescript-eslint/dot-notation
      const user = this.parseJwt(jwt['token'])
      const roomId = parseInt(user['roomId']);
      if (roomId && roomId > 0) {
        isAdminWithoutRoom = false;
      }
    })
    return isAdminWithoutRoom;
  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    // eslint-disable-next-line no-var
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

  getCardType(value: number, hours: number): string {
    if (value === 0) {
      if (hours) {
        return 'Sat(' + hours + 'h' + ')';
      } else {
        return 'Sat';
      }
    } else if (value === 1) {
      return 'Poludnevna karta';
    } else if (value === 2) {
      return 'Dnevna karta';
    } else {
      if (hours) {
        return 'Sat(' + hours + 'h' + ')';
      } else {
        return '';
      }
    }
  }
}
